import { ToneDto, ToneDtoImpl } from '../tonedto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { DateFormat } from '../../../ui/toolkit/dateformat/dateformat';
import { BaseContext } from '../../../utils/basecontext';

export class GetMusicBoxContentsBuilder {
    constructor(private getMusicBoxContentsList: any, private context: BaseContext) 
    {
        if(getMusicBoxContentsList.searchList  === undefined)
        {
            throw new NoDataException("Music Box contents data doesnt exists");
        }
    }

    buildAll(): ToneDto[] {
        return this.parseMusicBoxContentsResponse();
    }

    private parseMusicBoxContentsResponse(): ToneDto[] {
        let listOfMusicBoxContentsTone: ToneDto[] = [];
        
        let toneDto = null;
        this.getMusicBoxContentsList.searchList.forEach((musicBoxContentsItem: any) =>
        {
            toneDto = new ToneDtoImpl();
            toneDto.setId(musicBoxContentsItem.toneId);
            toneDto.setToneName(musicBoxContentsItem.toneName);
            toneDto.setImgPath(musicBoxContentsItem.toneIdpreviewImageUrl);
            toneDto.setToneUrl(musicBoxContentsItem.toneIdStreamingUrl);
            toneDto.setArtistName(musicBoxContentsItem.artistName);
            toneDto.setAlbumName(musicBoxContentsItem.album);
            toneDto.setCategoryId(musicBoxContentsItem.categoryId);
            toneDto.setLikeCount(musicBoxContentsItem.likeCount);
            toneDto.setExpirydate(DateFormat.formatExpiryDate(musicBoxContentsItem.expiryDate, this.context));
            listOfMusicBoxContentsTone.push(toneDto);
        });
        return listOfMusicBoxContentsTone;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/musicboxcontents/getmusicboxcontentsbuilder.ts